export class TranslatedText {

  constructor(
    public value?: string,
    public translated?: string
  ) { }
}
